import React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faCog,
  faBell,
  faList,
  faPencilAlt,
  faPlay,
  faPlus,
  faMinus,
  faEllipsisH,
  faPowerOff,
  faCloudUploadAlt,
  faBars,
  faSearch,
  faTimes,
  faMap,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCheck,
  faKey,
} from '@fortawesome/free-solid-svg-icons';

import { Switch, Route } from 'react-router-dom';

import Header from './components/layout/Header';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

import MonitorPage from './components/pages/MonitorPage.jsx';

import DisplayPage from './components/pages/DisplayPage.jsx';
import DisplayInfoPage from './components/pages/DisplayInfoPage.jsx';

// import DisplayGroupPage from './components/pages/DisplayGroups/Index';
// import DisplayGroupInfoPage from './components/pages/DisplayGroups/Details';

import CheckpointPage from './components/pages/CheckpointPage.jsx';
import CheckpointInfoPage from './components/pages/CheckpointInfoPage.jsx';

import CustomContentFilePage from './components/pages/CustomContentFilePage';
import CustomContentFileInfoPage from './components/pages/CustomContentFileInfoPage';
import CustomContentFileAssignmentPage from './components/pages/CustomContentFileAssignmentPage';
import CustomContentFileShowPage from './components/pages/CustomContentFileShowPage';

import LogPage from './components/pages/LogPage.jsx';
import UserDeviceActionsPage from './components/pages/UserDeviceActionsPage';
import ReportPage from './components/pages/ReportPage';

import UserLoginPage from './components/pages/UserLoginPage.jsx';
import UserPage from './components/pages/UserPage';
import UserDetailPage from './components/pages/UserDetailPage';
import UserProfilePage from './components/pages/UserProfilePage';

import PermissionDeniedPage from './components/pages/PermissionDeniedPage.jsx';
import GuestPage from './components/pages/GuestPage';
import NotFound from './components/pages/NotFound';

import Loader from './components/helpers/Loader';

import DisplaySettings from './components/pages/DisplaySettings';

import 'bootstrap/dist/css/bootstrap.css';
import * as api from './api/api';
import * as utils from './utils';

library.add(
  faUser,
  faCog,
  faBell,
  faList,
  faPencilAlt,
  faPlay,
  faPlus,
  faMinus,
  faEllipsisH,
  faPowerOff,
  faCloudUploadAlt,
  faBars,
  faSearch,
  faTimes,
  faCheck,
  faMap,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faKey,
);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loader: {
        loaded: false,
        message: '',
      },
    };

    this.updateLoader = this.updateLoader.bind(this);
  }

  updateLoader(newState) {
    this.setState({
      loader: newState,
    });
  }

  render() {
    const viewport = utils.getViewport();
    const className =
      viewport == 'xs' || viewport == 'sm' ? 'main' : 'd-flex main';

    return (
      <div className="d-flex flex-column App">
        <Header />
        <div className={className}>
          <Navbar />
          <main className="p-4 main__container">
            {/* <main className="p-4"> */}
            <div>
              <Loader
                loaded={this.state.loader.loaded}
                message={this.state.loader.message}
              />
              {api.isLogined() ? (
                <Switch>
                  <Route
                    path="/monitor"
                    render={() => (
                      <MonitorPage updateLoader={this.updateLoader} />
                    )}
                  />

                  <Route
                    exact
                    path="/displays"
                    render={() => (
                      <DisplayPage updateLoader={this.updateLoader} />
                    )}
                  />
                  <Route
                    exact
                    path="/checkpoints"
                    render={() => (
                      <CheckpointPage updateLoader={this.updateLoader} />
                    )}
                  />
                  <Route
                    exact
                    path="/"
                    render={() => (
                      <MonitorPage updateLoader={this.updateLoader} />
                    )}
                  />

                  <Route
                    exact
                    path="/logs"
                    render={(routeProps) => (
                      <LogPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/logs/:displayId"
                    render={(routeProps) => (
                      <LogPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/device-actions"
                    render={(routeProps) => (
                      <UserDeviceActionsPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  <Route
                    path="/displays/:id/details?"
                    render={(routeProps) => (
                      <DisplayInfoPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/displays/:id/details"
                    render={(routeProps) => (
                      <DisplayInfoPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  <Route
                    path="/displays/:id/settings"
                    render={(routeProps) => (
                      <DisplaySettings
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  <Route
                    path="/checkpoints/:id/details?"
                    render={(routeProps) => (
                      <CheckpointInfoPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/checkpoints/:id/details"
                    render={(routeProps) => (
                      <CheckpointInfoPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/custom-content"
                    render={() => (
                      <CustomContentFilePage updateLoader={this.updateLoader} />
                    )}
                  />
                  <Route
                    path="/custom-content/:id/details?"
                    render={(routeProps) => (
                      <CustomContentFileInfoPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/custom-content/:id/details"
                    render={(routeProps) => (
                      <CustomContentFileInfoPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/custom-content/:id/assignment?"
                    render={(routeProps) => (
                      <CustomContentFileAssignmentPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/custom-content/:id/assignment"
                    render={(routeProps) => (
                      <CustomContentFileAssignmentPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/custom-content/:id/show?"
                    render={(routeProps) => (
                      <CustomContentFileShowPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/custom-content/:id/show"
                    render={(routeProps) => (
                      <CustomContentFileShowPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  <Route
                    path="/reports"
                    render={() => (
                      <ReportPage updateLoader={this.updateLoader} />
                    )}
                  />

                  <Route
                    path="/users/permission-denied"
                    render={() => (
                      <PermissionDeniedPage updateLoader={this.updateLoader} />
                    )}
                  />

                  {/* <Route path="/users/register" render={() => <UserRegisterPage updateLoader={this.updateLoader} />} /> */}
                  <Route
                    exact
                    path="/users"
                    render={() => <UserPage updateLoader={this.updateLoader} />}
                  />
                  <Route
                    path="/users/:id/details"
                    render={(routeProps) => (
                      <UserDetailPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/users/:id/details?"
                    render={(routeProps) => (
                      <UserDetailPage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />
                  <Route
                    path="/users/login"
                    render={() => (
                      <UserLoginPage updateLoader={this.updateLoader} />
                    )}
                  />
                  <Route
                    exact
                    path="/lk/profile"
                    render={(routeProps) => (
                      <UserProfilePage
                        {...routeProps}
                        updateLoader={this.updateLoader}
                      />
                    )}
                  />

                  {/* <Route exact path="/display-groups" render={routeProps => <DisplayGroupPage {...routeProps} updateLoader={this.updateLoader} />} />
										<Route path="/display-groups/:id" render={routeProps => <DisplayGroupInfoPage {...routeProps} updateLoader={this.updateLoader} />} /> */}

                  <Route
                    render={() => <NotFound updateLoader={this.updateLoader} />}
                  />

                  {/* <Route render={() => <NotFound updateLoader={() => {}} />} /> */}
                </Switch>
              ) : (
                <Switch>
                  <Route
                    exact
                    path="/users/login"
                    render={() => (
                      <UserLoginPage updateLoader={this.updateLoader} />
                    )}
                  />
                  <Route
                    path="/"
                    render={() => (
                      <GuestPage updateLoader={this.updateLoader} />
                    )}
                  />
                </Switch>
              )}
            </div>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
